(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-discovery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-olea-pair-add]');
    if (!button || button.disabled) return;

    const status = button.closest('.olea-pairing').querySelector('.olea-pairing__status');
    const label = button.textContent;
    const root = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.loadingLabel;
    status.textContent = '';

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            { id: Number(button.dataset.variantA), quantity: 1 },
            { id: Number(button.dataset.variantB), quantity: 1 }
          ]
        })
      });

      if (!response.ok) throw new Error('cart-add-failed');
      window.location.assign(root + 'cart');
    } catch {
      status.textContent = button.dataset.errorLabel;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
